import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import devToolsPlugin from '@backstage/plugin-devtools/alpha';
import { devToolsAdministerPermission } from '@backstage/plugin-devtools-common';
import { RequirePermission } from '@backstage/plugin-permission-react';

export const devToolsModule = createFrontendModule({
  pluginId: devToolsPlugin.pluginId,
  extensions: [
    // ── Route (→ app/routes) ────────────────────────────────
    PageBlueprint.make({
      params: {
        path: '/devtools',
        noHeader: true,
        routeRef: devToolsPlugin.routes.root,
        loader: () =>
          import('../components/devtools/CustomDevToolsPage').then(m => (
            <RequirePermission permission={devToolsAdministerPermission}>
              <m.CustomDevToolsPage />
            </RequirePermission>
          )),
      },
    }),
  ],
});
